// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"192":"010d361b","3376":"fcf2c81d","5199":"7ca6b8eb","8886":"010d361b","9756":"61adac02"}[chunkId] + ".chunk.css";
};